import { InjectionToken } from '@angular/core';

/**
 * Typed, centralized public-facing URLs that used to be hardcoded string
 * literals scattered across component templates (footer, header, calculator,
 * hybrid-mail). Two kinds of value live here:
 *  - Genuinely static links (app stores, messengers, the citizen portal) —
 *    the same in every environment, just no longer duplicated per template.
 *  - Links derived from `ApiConfiguration.contentUrl` (the uploaded PDFs) —
 *    previously hardcoded to the production content host directly, which
 *    meant a `development`/`staging` build silently linked to production
 *    documents. See `buildPublicLinksConfig()` for how these are built.
 */
export interface PublicLinksConfig {
  readonly citizenPortalUrl: string;
  readonly citizenPortalLoginUrl: string;
  readonly appStoreUrl: string;
  readonly googlePlayUrl: string;
  readonly whatsAppUrl: string;
  readonly telegramUrl: string;
  readonly dispatchTypesPdfUrl: string;
  readonly prohibitedItemsPdfUrl: string;
}

export const PUBLIC_LINKS_CONFIG = new InjectionToken<PublicLinksConfig>('PUBLIC_LINKS_CONFIG');
